module.exports = __webpack_public_path__ + "static/media/lock.57eae3b0.svg";